<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" style="background-color: #2b65d8;">
      <b-navbar-brand to="/">Listado Médico</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item-dropdown text="Directorio">
            <b-dropdown-item to="/doctors">Médicos</b-dropdown-item>
            <b-dropdown-item to="/hospitals">Hospitales</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item to="/about">Nosotros</b-nav-item>
          <b-nav-item to="/contact">Contacto</b-nav-item>
        </b-navbar-nav>

        <!-- <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown text="Menú médicos" right>
            <template v-if="!$store.state.doctor">
              <b-dropdown-item to="/signup">Registro</b-dropdown-item>
              <b-dropdown-item to="/signin">Entrar</b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item to="/profile">Perfil</b-dropdown-item>
              <b-dropdown-item to="/offices">Consultorios</b-dropdown-item>
              <b-dropdown-item to="/logout">Salir</b-dropdown-item>
            </template>
          </b-nav-item-dropdown>
        </b-navbar-nav> -->
      </b-collapse>
    </b-navbar>
    <b-container fluid class="flex-fill m-0 p-0" role="main">
      <router-view></router-view>
    </b-container>
    <footer class="container-fluid bg-secondary m-0 p-0">
      <b-container class="text-white pt-3">
        <b-row>
          <b-col xl="6">
            <h5>{{ $t('footer.title') }}</h5>
            <p>{{ $t('footer.description') }}</p>
          </b-col>
          <b-col xl="2">
            <h5>{{ $t('footer.beginning') }}</h5>
            <ul class="list-unstyled">
              <li>
                <b-link class="text-white" to="/doctors">Encuentra médicos</b-link>
              </li>
              <li>
                <b-link class="text-white" to="/hospitals">Encuentra hospitales</b-link>
              </li>
              <!-- <li>
                <b-link class="text-white" to="/signup">Registrarse</b-link>
              </li> -->
              <!-- <li>
                <b-link class="text-white" to="/signin">Acceso para doctores</b-link>
              </li> -->
            </ul>
          </b-col>
          <b-col col xl="2">
            <h5>{{ $t('footer.info') }}</h5>
            <ul class="list-unstyled">
              <li>
                <b-link class="text-white" to='/tos'>Términos</b-link>
              </li>
              <li>
                <b-link class="text-white" to='/privacy'>Privacidad</b-link>
              </li>
              <li>
                <b-link class="text-white" to='/about'>Sobre nosotros</b-link>
              </li>
            </ul>
          </b-col>
          <b-col col xl="2" class="text-left">
            <h5>{{ $t('footer.social') }}</h5>
            <ul class="list-unstyled">
              <li>
                <b-link class="nav-link text-light" target="_blank" href="//facebook.com/listadomedico">
                  <font-awesome-icon :icon="['fab', 'facebook-square']" size="lg" />
                </b-link>
              </li>
              <li>
                <b-link class="nav-link text-light" target="_blank" href="//twitter.com/listadomedico">
                  <font-awesome-icon :icon="['fab', 'twitter']" size="lg" />
                </b-link>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid class="m-0 p-2 text-white bg-dark">
        <p class="m-0 text-center">&copy; {{ year }} Listado Médico</p>
      </b-container>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  metaInfo: {
    title: 'Listado Médico',
    titleTemplate: '%s | Encuentra médicos y hospitales cercanos a tu ubicación',
    meta: [
      { vmid: 'description', name: 'description', content: 'Listado Médico te ayuda a encontrar médicos y hospitales cercanos a tu ubicación' },
      { vmid: 'keywords', name: 'keywords', content: 'médicos, hospitales, doctores, listadomedico' }
    ]
  },
  mounted () {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.VUE_APP_FACEBOOK_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v6.0'
      })
    }
  }
}
</script>
<style>
  body {
    min-height: 100vh;
  }
</style>
